@if (previsiones().length > 0) {
  <table class="tabla">
    <thead>
      <tr>
        <th class="articulos-column">
          {{ 'COMPARTIDOS.PREVISIONES_TABLE.ARTICULO' | translate }}
        </th>

        @for (articulo of previsiones()[0].data; track $index) {
          <th
            [ngClass]="{
              isFestivo: articulo.isFestivo,
            }"
          >
            {{ articulo.fecha | date: 'EEE, dd/MM/yyyy' }}
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (item of previsiones(); track $index) {
        <tr>
          <td
            class="articulos-column"
            [attr.data-label]="
              'COMPARTIDOS.PREVISIONES_TABLE.ARTICULO' | translate
            "
          >
            {{ item.descripcionArticulo }}
          </td>

          @for (articulo of item.data; track $index) {
            <td [attr.data-label]="articulo.fecha | date: 'EEE, dd/MM/yyyy'">
              {{ articulo.huecos }}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}
